import { DataSource, isQueryDataSource } from '@softapps/core';
import { PageFilterDataService } from './page-filter-data.service';
import { PageFilterQueryDataService } from './page-filter-query-data.service';
import { PageFilterArrayDataService } from './page-filter-array-data.service';
import { Signal } from '@angular/core';
import { QueryFilter } from '@softline/core';

export function pageFilterDataServiceFactory<T extends object>(dataSource: DataSource<T>, baseFilter?: Signal<QueryFilter<T>>): PageFilterDataService<T> {
  if(isQueryDataSource(dataSource))
    return new PageFilterQueryDataService(dataSource, baseFilter);
  // array | Signal<array> | Resource<array>: the remaining DataSource arms are
  // client-side rows, filtered in memory instead of by a value query
  return new PageFilterArrayDataService(dataSource, baseFilter);
}
